import React, { useMemo, useState } from "react";

import moment from "moment-timezone";
import Select from "../../select";
const currentYear = new Date().getFullYear();

export function formatDob(value: string): { day: string | number; month: string | number; year: string | number } {
	let [day, month, year] = [null, null, null];
	if (value) {
		[year, month, day] = value.split("-");
	}

	return { day, month, year };
}

export function parseDob(value: number[], name): string {
	if (value === null) {
		value = [null, null, null];
	}

	const [day, month, year] = value;
	return `${year}-${month}-${day}`;
}

const createDays = () => {
	let days = [];
	for (let i = 1; i <= 31; i++) {
		days.push({
			value: i.toString(),
			label: i.toString(),
		});
	}

	return days;
};

const createMonths = () => {
	return Array.apply(0, Array(12)).map(function (_, i) {
		return {
			value: i <= 8 ? "0" + (i + 1) : i + 1,
			label: moment().month(i).format("MMMM"),
		};
	});
};

const createYears = (delta = 120) => {
	const oldestYear = currentYear - delta;
	let years = [];
	for (let i = currentYear; i >= oldestYear; i--) {
		years.push({
			value: i.toString(),
			label: i.toString(),
		});
	}

	return years;
};

const DoBSelect = ({
	input: { onChange, value, name },
	dayPrompt,
	monthPrompt,
	yearPrompt,
	customOnChange = null,
	...rest
}) => {
	const days = useMemo(() => createDays(), []);
	const months = useMemo(() => createMonths(), []);
	const years = useMemo(() => createYears(), []);

	const [day, setDay] = useState(value.day);
	const [month, setMonth] = useState(value.month);

	const [year, setYear] = useState(value.year);

	const updateDay = (day) => {
		setDay(day);
		onChange([day, month, year]);
		if (customOnChange) {
			customOnChange([day, month, year]);
		}
	};

	const updateMonth = (month) => {
		setMonth(month);
		onChange([day, month, year]);
		if (customOnChange) {
			customOnChange([day, month, year]);
		}
	};

	const updateYear = (year) => {
		setYear(year);
		onChange([day, month, year]);
		if (customOnChange) {
			customOnChange([day, month, year]);
		}
	};

	return (
		<div className="dobSelect">
			<div className="select day">
				<Select name="dobDay" prompt={dayPrompt} items={days} value={day} onChange={updateDay} />
				<div className="icon" />
			</div>
			<div className="select month">
				<Select name="dobMonth" prompt={monthPrompt} items={months} value={month} onChange={updateMonth} />
				<div className="icon" />
			</div>
			<div className="select year">
				<Select name="dobYear" prompt={yearPrompt} items={years} value={year} onChange={updateYear} />
				<div className="icon" />
			</div>
		</div>
	);
};

export default DoBSelect;
